import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import styleable from 'react-styleable';
import defaultStyle from './tooltip.style.js';
import { accessibilityNotificationsEmitter } from '../';

const tooltipArrowHeight = 10;
const tooltipArrowWidth = 20;
const arrowMargin = 10;

export class TooltipDisplay extends Component {
  constructor(props){
    super(props);


    this.state = {
      style: {
        maxWidth: window.outerWidth / 2
        },
      classes: "",
      showTooltip: false,
    }

    this.toggleTooltip = this.toggleTooltip.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.updateTooltipPosition = this.updateTooltipPosition.bind(this);
    this.handleKeyboardInput = this.handleKeyboardInput.bind(this);

    document.body.addEventListener("click", this.toggleTooltip);
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUpdate(nextProps, nextState) {
    const { style } = this.state;
    const { style : nextStyle } = nextState;

    if(nextStyle.maxWidth !== style.maxWidth) {
      this.updateTooltipPosition(nextStyle);
    }
  }

  handleResize() {
    this.setState({
      style: {
        maxWidth: window.outerWidth / 2
      }
    })
  }

  updateTooltipPosition(currentStyle) {
    const windowWidth = window.outerWidth;
    const tooltip = this.tooltip;
    const anchor = this.anchor;

    var style = currentStyle;
    var classes = "";

    var posTop, posBottom, posLeft, posRight;

    // if putting the tooltip above the anchor causes it to go off the screen put it below
    if(anchor.offsetTop - tooltip.clientHeight - tooltipArrowHeight < 0) {
      classes += " top";
      posTop = (anchor.offsetHeight  / 2 ) + tooltipArrowHeight;
    }
    else {
      classes += " bottom";
      posBottom = (anchor.offsetHeight  / 2 ) + tooltipArrowHeight;
    }

    if(anchor.offsetLeft + anchor.offsetWidth + tooltip.clientWidth + tooltipArrowWidth > windowWidth) {
      classes += " right";
      posRight = -(anchor.offsetWidth + arrowMargin) / 2;
    }
    else {
      classes += " left";
      posLeft = -(anchor.offsetWidth + arrowMargin) / 2;
    }

    style.top = posTop;
    style.bottom = posBottom;
    style.left = posLeft;
    style.right = posRight;

    this.setState({
      style,
      classes
    });
  }

  toggleTooltip(e) {
    const { text } = this.props;
    const { style, showTooltip } = this.state;

    this.updateTooltipPosition(style);

    if(showTooltip && e.target !== this.tooltip) {
      this.setState({
        showTooltip: false,
      });
    }
    else if(!showTooltip && (e.target === this.anchor || e.target === this.icon)) {
      accessibilityNotificationsEmitter.assertive(text);
      this.setState({
        showTooltip: true,
      });
    }
  }

  handleKeyboardInput(e) {
    if(e.keyCode === 13 || e.keyCode === 32) {
      this.toggleTooltip(e);
    }
  }

  render() {
    const { context, text, css } = this.props;
    const { classes, style, showTooltip } = this.state;

    var showClass = showTooltip ? ' shown' : '';

    var ariaLabel = !!context ? context + ': ' : '';
    ariaLabel += showTooltip ? 'Hide Tooltip' : 'Show Tooltip';

    return (
      <div
        aria-label={ariaLabel}
        ref={(el) => { this.anchor = el; }}
        className={css.tooltip}>
        <p ref={(el) => { this.tooltip = el; }} style={style} className={css.tooltipText + classes + showClass}>{text}</p>
        <span
          ref={(el) => { this.icon = el; }}
          tabIndex={0}
          role="button"
          onKeyDown={e => this.handleKeyboardInput(e)}
          className={css.icon}/>
      </div>
    );
  }
}

TooltipDisplay.propTypes = {
  context: PropTypes.string,
  text: PropTypes.string,
  css: PropTypes.object,
};

export default styleable(defaultStyle) (TooltipDisplay);



// WEBPACK FOOTER //
// src/common/tooltip-display/tooltip-display.js